import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import LayoutContainer from '../shared/LayoutContainer'
import Formular from './Formular'
import Location from './Location'

import styles from './Contact.module.css'
import Text from '../shared/Text'

const Contact = () => {
  return (
    <LayoutContainer>
      <h2>Kontakt</h2>
      <Text>
        Sie wollen mit <b>Mt.Olives Prayer & Worship</b> Kontakt aufnehmen? Dann sind sie hier
        richtig.
      </Text>
      <Text>
        Bei Fragen oder Problemen mit unseren Webseiten finden Sie unseren
        Verantwortlichen im Impressum.
      </Text>
      <Text>
        Für alle weiteren Fragen zu uns, zu <b>Mt.Olives</b> oder zu unserem
        Glauben an Jesus Christus wenden Sie sich bitte an die folgende Adresse.{' '}
      </Text>
      <Text>Wir freuen uns auf Ihre Nachricht!</Text>
      <h2>Anschrift</h2>
      <Text>
        <b>Mt.Olives Prayer & Worship</b>
      </Text>
      <Text>
        c/o Gudrun Holzmayer<br />
        Beim Reifenbrünnele 7<br />
        72531 Meidelstetten<br />
        t: +49(0)7387/9845270<br />
        kontakt@mtolives.org<br />
      </Text>
      <h2>Treffpunkt</h2>
      <Text>Wir treffen uns in der Regel Dienstag abends hier (s. Termine)</Text>
      <Grid>
        <Row className={styles.container}>
          <Col xs={12} sm={5}>
            <b>Mt.Olives Prayer & Worship</b> <br />
            Beim Reifenbrünnele 7 <br />
            72531 Meidelstetten <br />
            t: +49(0)7387/9845270<br />
          </Col>
          <Col xs={12} className={styles.locationContainer}>
            <Location />
          </Col>
        </Row>
      </Grid>
    </LayoutContainer>
  )
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/contact/Contact.js